<!-- Merge Completed Dialog -->
<p-dialog
  [(visible)]="showMergeCompletedDialog"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '450px' }"
  [header]="'MERGE_COMPLETED' | translate"
  styleClass="merge-completed-dialog">
  <div class="merge-completed-content">
    <div class="d-flex align-items-center">
      <i class="pi pi-check-circle merge-completed-icon"></i>
      <div class="merge-completed-text">
        <p>{{ 'MERGE_COMPLETED_GIT_MESSAGE' | translate }}</p>
        <p class="mt-2 mb-0">
          <a [href]="getTargetApplicationUrl()" target="_blank" class="target-app-link">
            {{ 'GO_TO_TARGET_APPLICATION' | translate: { targetBranch: targetBranch?.refsName } }}
            <i class="pi pi-external-link ml-1"></i>
          </a>
        </p>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary" (click)="closeMergeCompletedDialog()">
      {{ 'CLOSE' | translate }}
    </button>
  </ng-template>
</p-dialog>

<!-- Merge Failed Dialog -->
<p-dialog
  [(visible)]="showMergeFailedDialog"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '450px' }"
  [header]="'MERGE_FAILED' | translate"
  styleClass="merge-completed-dialog merge-failed-dialog">
  <div class="merge-completed-content">
    <div class="d-flex align-items-center">
      <i class="pi pi-times-circle merge-failed-icon"></i>
      <div class="merge-completed-text">
        <p>{{ mergeFailedMessage }}</p>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary" (click)="closeMergeFailedDialog()">
      {{ 'CLOSE' | translate }}
    </button>
  </ng-template>
</p-dialog>

<div class="merge-branch-container">
  <div class="dialog-header-container">
    <div class="d-flex justify-content-between w-100">
      <span class="dialog-header">{{ 'MERGE_BRANCH_TITLE' | translate }} :
        <span class="dialog-subheader">
          {{ sourceBranch?.refsName || ('MERGE_SELECT_BRANCH' | translate) }}
          <span *ngIf="unPublishedSource" class="custom-badge ml-2">
            <i pTooltip="{{ 'UNPUBLISHED_CHANGES_HEADER' | translate }}" tooltipPosition="top"
                    class="pi pi-exclamation-triangle ml-1"></i>          </span>
          <ng-container *ngIf="targetBranch">
            <i class="pi pi-arrow-right header-arrow-icon"></i>
            {{ targetBranch.refsName }}
          </ng-container>
          <span *ngIf="unPublishedTarget" class="custom-badge ml-2">
             <i pTooltip="{{ 'UNPUBLISHED_CHANGES_HEADER' | translate }}" tooltipPosition="top"
                    class="pi pi-exclamation-triangle ml-1"></i>  
          </span>
        </span>
      </span>
      <div>
        <button type="button" (click)="!isMergeInProgress && onClose()" (keydown.enter)="!isMergeInProgress && onClose()" tabindex="0" aria-label="close popup"
          [class.disabled-close]="isMergeInProgress" [attr.aria-disabled]="isMergeInProgress"
          class="close-popup-btn">
          <i class="pi pi-times-circle close-icon" [class.disabled]="isMergeInProgress"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="dialog-body">
    <p-tabs [(value)]="activeIndex">
      <p-tablist>
        <p-tab [value]="0" [disabled]="true">
          <div class="tab-label-container first-tab" [ngClass]="{ 'step-done': isStep1Complete && activeIndex > 0 }">
            <div class="header-btn">1</div>
            <p>{{ 'MERGE_SELECT_BRANCH' | translate }}</p>
          </div>
        </p-tab>
        <p-tab [value]="1" [disabled]="true">
          <div [ngClass]="{
              'tab-label-container': true,
              'br-left': activeIndex >= 2,
              'br-right': activeIndex === 0,
              'step-done': activeIndex > 1
            }">
            <div class="header-btn">2</div>
            <p>{{ 'VIEW_AND_SELECT_CHANGES' | translate }}</p>
          </div>
        </p-tab>
        <p-tab [value]="2" [disabled]="true">
          <div [ngClass]="{
              'tab-label-container': true,
              'br-left': activeIndex === 3,
              'step-done': activeIndex > 2
            }">
            <div class="header-btn">3</div>
            <p>{{ 'REVIEW' | translate }}</p>
          </div>
        </p-tab>
        <p-tab [value]="3" [disabled]="true">
          <div class="tab-label-container last-tab">
            <div class="header-btn">4</div>
            <p>{{ 'CONFIRM_MERGE' | translate }}</p>
          </div>
        </p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel [value]="0">
          <div class="step-content">
            <div class="branch-selection-container">
              <div class="branch-field">
                <span class="field-label">{{ 'MERGE_SOURCE_BRANCH' | translate }}</span>
                <div class="source-branch-display">
                  <i class="pi pi-share-alt branch-icon"></i>
                  <span class="branch-name">{{ sourceBranch?.refsName || ('NO_BRANCH_SELECTED' | translate) }}</span>
                </div>
                <div class="warning-message" *ngIf="unPublishedSource">
                  <i pTooltip="{{ 'UNPUBLISHED_CHANGES_TOOLTIP' | translate }}" tooltipPosition="top"
                    class="pi pi-exclamation-circle ml-1"></i>
                  {{ 'BRANCH_HAS_UNPUBLISHED_CHANGES' | translate }}
                </div>
                </div>

              <div class="branch-field">
                <label class="field-label" for="targetBranchSelect">{{ 'TARGET_BRANCH' | translate }} <span class="required">*</span></label>
                <p-select
                  inputId="targetBranchSelect"
                  [options]="availableBranches"
                  [(ngModel)]="targetBranch"
                  optionLabel="label"
                  optionValue="value"
                  [placeholder]="'SELECT_TARGET_BRANCH' | translate"
                  [loading]="loadingBranches"
                  [filter]="true"
                  [filterPlaceholder]="'SEARCH_BRANCHES' | translate"
                  [styleClass]="(targetBranchHasOngoingMerge || targetBranchDeleted) ? 'branch-dropdown ng-invalid ng-dirty' : 'branch-dropdown'"
                  (onChange)="onTargetBranchChange($event)">
                  <ng-template #selectedItem>
                    <div class="branch-option" *ngIf="targetBranch">
                      <span>{{ targetBranch.refsName }}</span>
                    </div>
                  </ng-template>
                  <ng-template #item let-branch>
                    <div class="branch-option">
                      <i class="pi pi-share-alt"></i>
                      <span>{{ branch.label }}</span>
                    </div>
                  </ng-template>
                </p-select>
                <div class="warning-message" *ngIf="unPublishedTarget">
                  <i pTooltip="{{ 'UNPUBLISHED_CHANGES_TOOLTIP' | translate }}" tooltipPosition="top"
                    class="pi pi-exclamation-circle ml-1"></i>
                  {{ 'BRANCH_HAS_UNPUBLISHED_CHANGES' | translate }}
                </div>
                <!-- Ongoing merge error for target branch -->
                <div class="ongoing-merge-error" *ngIf="targetBranchHasOngoingMerge">
                  <i class="pi pi-exclamation-circle"></i>
                  <span>{{ 'MERGE_IN_PROGRESS_FOR_TARGET_BRANCH' | translate }}</span>
                </div>
                <!-- Target branch deleted warning -->
                <div class="ongoing-merge-error" *ngIf="targetBranchDeleted">
                  <i class="pi pi-exclamation-triangle"></i>
                  <span>{{ 'TARGET_BRANCH_DELETED' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </p-tabpanel>
        <p-tabpanel [value]="1">
          <div class="step-content step-2-content">
            <!-- Error State for Step 2 -->
            <div class="review-error" *ngIf="isProcessRunning && !loadingChanges">
              <i class="pi pi-exclamation-triangle"></i>
              <span>{{ processWarningMessage }}</span>
            </div>

            <!-- Filters and Bulk Action -->
              <div class="changes-toolbar" *ngIf="!isProcessRunning">
                <div class="filter-dropdowns">
                  <!-- Application Filter (Suite Merge only) -->
                    <p-floatlabel variant="on" *ngIf="isSuiteMerge">
                      <p-multiSelect
                        inputId="application-filter"
                        [options]="applicationOptions"
                        [(ngModel)]="filterApplications"
                        (ngModelChange)="onFilterChange()"
                        [showClear]="true"
                        [filter]="true"
                        styleClass="filter-multiselect"
                        appendTo="body">
                      </p-multiSelect>
                      <label for="application-filter">{{ 'APPLICATION' | translate }}</label>
                    </p-floatlabel>
                  <!-- Component Type -->
                  <p-floatlabel variant="on">
                    <p-multiSelect
                      inputId="component-type-filter"
                      [options]="componentTypeOptions"
                      [(ngModel)]="filterComponentTypes"
                      (ngModelChange)="onFilterChange()"
                      [showClear]="true"
                      [filter]="true"
                      styleClass="filter-multiselect"
                      appendTo="body">
                    </p-multiSelect>
                    <label for="component-type-filter">{{ 'MERGE_COMPONENT_TYPE' | translate }}</label>
                  </p-floatlabel>
                  <!-- Change Type -->
                  <p-floatlabel variant="on">
                    <p-multiSelect
                      inputId="change-type-filter"
                      [options]="changeTypeOptions"
                      [(ngModel)]="filterChangeTypes"
                      (ngModelChange)="onFilterChange()"
                      [showClear]="true"
                      styleClass="filter-multiselect"
                      appendTo="body">
                    </p-multiSelect>
                    <label for="change-type-filter">{{ 'CHANGE_TYPE' | translate }}</label>
                  </p-floatlabel>

                  <!-- Action -->
                  <p-floatlabel variant="on">
                    <p-multiSelect
                      inputId="action-type-filter"
                      [options]="actionTypeOptions"
                      [(ngModel)]="filterActionTypes"
                      (ngModelChange)="onFilterChange()"
                      [showClear]="true"
                      styleClass="filter-multiselect"
                      appendTo="body">
                    </p-multiSelect>
                    <label for="action-type-filter">{{ 'SELECT_ALL' | translate }}</label>
                  </p-floatlabel>

                  <!-- Modified By -->
                  <p-floatlabel variant="on">
                    <p-multiSelect
                      inputId="modified-by-filter"
                      [options]="modifiedByOptions"
                      [(ngModel)]="filterModifiedBy"
                      (ngModelChange)="onFilterChange()"
                      [showClear]="true"
                      styleClass="filter-multiselect"
                      appendTo="body">
                    </p-multiSelect>
                    <label for="modified-by-filter">{{ 'MODIFIED_BY' | translate }}</label>
                  </p-floatlabel>

                  <!-- Conflicts Filter - Only shown when there are conflicts -->
                  <p-floatlabel variant="on" *ngIf="getErrorCount() > 0">
                    <p-multiSelect
                      inputId="conflict-filter"
                      [options]="conflictOptions"
                      [(ngModel)]="filterConflicts"
                      (ngModelChange)="onFilterChange()"
                      [showClear]="true"
                      styleClass="filter-multiselect"
                      appendTo="body">
                    </p-multiSelect>
                    <label for="conflict-filter">{{ 'HAS_CONFLICT' | translate }}</label>
                  </p-floatlabel>

                  <button
                    *ngIf="hasActiveFilters"
                    pButton
                    type="button"
                    [label]="'CLEAR_FILTERS' | translate"
                    class="p-button-outlined p-button-sm clear-all-btn"
                    (click)="clearFilters()">
                  </button>
                </div>

                <!-- Comparison Info - Right aligned -->
                <div class="comparison-badge">
                  <ng-container *ngIf="!noMergesDone; else noMergesTemplate">

                    <div class="comparison-date-info">
                      <div class="comparison-main-line">
                        <i class="pi pi-calendar"></i>
                        <span>{{ 'COMPARING_CHANGES_SINCE_LAST_MERGE' | translate }} <strong>{{ comparisonDate | date:defaultDateTimeDisplayFormat }}</strong></span>
                      </div>
                      <span class="no-merges-subtext">{{ 'MERGE_LATER_MSG' | translate }}</span>
                    </div>

                  </ng-container>
                  <ng-template #noMergesTemplate>
                    <div class="comparison-date-info">
                      <div class="comparison-main-line">
                        <i class="pi pi-calendar"></i>
                        <span>{{ 'CHANGES_SINCE_CREATED_DATE' | translate }} <strong>{{ comparisonDate | date:defaultDateTimeDisplayFormat }}</strong></span>
                      </div>
                      <span class="no-merges-subtext">{{ 'NO_MERGES_FROM_THIS_BRANCH_SINCE_CREATED' | translate }}</span>
                    </div>
                  </ng-template>
                </div>
              </div>

              <!-- Changes Table -->
              <div class="changes-table-container">
                <p-table
                  [value]="mergeChanges"
                  [scrollable]="true"
                  scrollHeight="calc(100vh - 430px)"
                  [resizableColumns]="true"
                  columnResizeMode="fit"
                  styleClass="merge-changes-table">
                  <ng-template pTemplate="header">
                    <tr>
                        <!-- Application Column (Suite Merge only) -->
                        <th *ngIf="isSuiteMerge" scope="col" pResizableColumn class="sortable" style="width: 12%;">
                          {{ 'APPLICATION' | translate }}
                        </th>
                      <th scope="col" pResizableColumn (click)="onSort('componentType')" (keydown.enter)="onSort('componentType')" class="sortable" style="width: 12%;">
                        {{ 'COMPONENT_TYPE' | translate }}
                        <span *ngIf="sortField === 'componentType'">
                          <i class="pi" [ngClass]="{'pi-sort-amount-up-alt': sortOrder === 'asc', 'pi-sort-amount-down': sortOrder === 'desc'}"></i>
                        </span>
                      </th>
                     
                      <th scope="col" pResizableColumn (click)="onSort('recordChangeType')" (keydown.enter)="onSort('recordChangeType')" class="sortable" style="width: 16%;">
                        {{ 'CHANGE_TYPE' | translate }}
                        <span *ngIf="sortField === 'recordChangeType'">
                          <i class="pi" [ngClass]="{'pi-sort-amount-up-alt': sortOrder === 'asc', 'pi-sort-amount-down': sortOrder === 'desc'}"></i>
                        </span>
                      </th>
                      <th scope="col" pResizableColumn class="source-column-header sortable" style="width: 20%;" (click)="onSort('sourceComponentName')" (keydown.enter)="onSort('sourceComponentName')">
                        {{ 'SOURCE_INFO' | translate }}
                        <span *ngIf="sortField === 'sourceComponentName' || sortField === 'lastSourceModification'">
                          <i class="pi" [ngClass]="{'pi-sort-amount-up-alt': sortOrder === 'asc', 'pi-sort-amount-down': sortOrder === 'desc'}"></i>
                        </span>
                      </th>
                      <th scope="col" pResizableColumn class="target-column-header sortable" style="width: 20%;" (click)="onSort('targetComponentName')" (keydown.enter)="onSort('targetComponentName')">
                        {{ 'TARGET_INFO' | translate }}
                        <span *ngIf="sortField === 'targetComponentName' || sortField === 'lastTargetModification'">
                          <i class="pi" [ngClass]="{'pi-sort-amount-up-alt': sortOrder === 'asc', 'pi-sort-amount-down': sortOrder === 'desc'}"></i>
                        </span>
                      </th>
                      <th scope="col" pResizableColumn class="pick-column-header" style="width: 24%;">
                        <div class="pick-header-content">
                          <span class="pick-header-label">{{ 'SELECT_ALL' | translate }}</span>
                          <div class="pick-checkboxes">
                            <p-checkbox
                              [(ngModel)]="selectAllSource"
                              [binary]="true"
                              [disabled]="hasNoChanges"
                              (onChange)="onSelectAllSource()"
                              inputId="selectAllSourcePick"
                              [pTooltip]="'SELECT_ALL_AS' | translate: { branchName: sourceBranch?.refsName }"
                              tooltipPosition="top"
                              appendTo="body">
                            </p-checkbox>
                            <label for="selectAllSourcePick" class="checkbox-label" [pTooltip]="sourceBranch?.refsName" tooltipPosition="top" appendTo="body">{{ sourceBranch?.refsName }}</label>

                            <p-checkbox
                              [(ngModel)]="selectAllTarget"
                              [binary]="true"
                              [disabled]="hasNoChanges"
                              (onChange)="onSelectAllTarget()"
                              inputId="selectAllTargetPick"
                              [pTooltip]="'SELECT_ALL_AS' | translate: { branchName: targetBranch?.refsName }"
                              tooltipPosition="top"
                              appendTo="body">
                            </p-checkbox>
                            <label for="selectAllTargetPick" class="checkbox-label" [pTooltip]="targetBranch?.refsName" tooltipPosition="top" appendTo="body">{{ targetBranch?.refsName }}</label>

                            <p-checkbox
                              [(ngModel)]="selectAllDontMerge"
                              [binary]="true"
                              [disabled]="hasNoChanges"
                              (onChange)="onSelectAllDontMerge()"
                              inputId="selectAllDontMergePick"
                              [pTooltip]="'SELECT_MERGE_LATER_ALL' | translate"
                              tooltipPosition="top"
                              appendTo="body">
                            </p-checkbox>
                            <label for="selectAllDontMergePick" class="checkbox-label" [pTooltip]="'MERGE_LATER' | translate" tooltipPosition="top" appendTo="body">{{ 'MERGE_LATER' | translate }}</label>
                          </div>
                        </div>
                      </th>
                      <th scope="col" style="width: 6%;">{{ 'CONFLICTS_UPPERCASE' | translate }}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-change>
                    <tr [ngClass]="{'has-error': change.hasError, 'has-conflict': change.hasConflict}">
                       <!-- Application Cell (Suite Merge only) -->
                       <td *ngIf="isSuiteMerge">
                          <span>{{ change.applicationName }}</span>
                        </td>
                      <td>
                        <span class="component-type-text" [pTooltip]="utilService.formatComponentType(change.componentType)" tooltipPosition="top" appendTo="body">{{ utilService.formatComponentType(change.componentType) }}</span>
                      </td>
                      <td>
                        <span class="change-type-badge" [ngClass]="getChangeTypeClass(change.recordChangeType)">
                          {{ getChangeTypeDisplayLabel(change) }}
                        </span>
                      </td>
                      <td class="combined-source-cell" [class.empty-cell]="!change.sourceComponentName">
                        <div class="combined-cell-content" [class.empty-cell]="!change.sourceComponentName">
                          <div class="component-path-row" *ngIf="change.sourceComponentName">
                            <ng-container *ngIf="change.sourceComponentPath">
                              <span class="path-name" [pTooltip]="getPathName(change.sourceComponentPath)" tooltipPosition="top" appendTo="body">{{ getPathName(change.sourceComponentPath) }}</span>
                              <span class="path-type-badge">{{ getPathTypeLabel(change.sourceComponentPath) }}</span>
                              <i class="path-arrow pi pi-arrow-right"></i>
                            </ng-container>
                            <span class="component-name" [pTooltip]="change.sourceComponentName" tooltipPosition="top" appendTo="body">{{ change.sourceComponentName }}</span>
                            <span class="component-type-badge">{{ utilService.formatComponentType(change.componentType) }}</span>
                          </div>
                          <span class="empty-placeholder" *ngIf="!change.sourceComponentName">-</span>
                          <div class="modification-info" *ngIf="change.lastSourceModifier">
                            <span class="author-name">{{ getUserDisplayName(change.lastSourceModifier) }}</span>
                            <span class="separator">•</span>
                            <span class="author-date">{{ change.lastSourceModification | date:defaultDateTimeDisplayFormat }}</span>
                          </div>
                        </div>
                      </td>
                      <td class="combined-target-cell" [class.empty-cell]="!change.targetComponentName">
                        <div class="combined-cell-content" [class.empty-cell]="!change.targetComponentName">
                          <div class="component-path-row" *ngIf="change.targetComponentName">
                            <ng-container *ngIf="change.targetComponentPath">
                              <span class="path-name" [pTooltip]="getPathName(change.targetComponentPath)" tooltipPosition="top" appendTo="body">{{ getPathName(change.targetComponentPath) }}</span>
                              <span class="path-type-badge">{{ getPathTypeLabel(change.targetComponentPath) }}</span>
                              <i class="path-arrow pi pi-arrow-right"></i>
                            </ng-container>
                            <span class="component-name" [pTooltip]="change.targetComponentName" tooltipPosition="top" appendTo="body">{{ change.targetComponentName }}</span>
                            <span class="component-type-badge">{{ utilService.formatComponentType(change.componentType) }}</span>
                          </div>
                          <span class="empty-placeholder" *ngIf="!change.targetComponentName">-</span>
                          <div class="modification-info" *ngIf="change.lastTargetModifier">
                            <span class="author-name">{{ getUserDisplayName(change.lastTargetModifier) }}</span>
                            <span class="separator">•</span>
                            <span class="author-date">{{ change.lastTargetModification | date:defaultDateTimeDisplayFormat }}</span>
                          </div>
                        </div>
                      </td>
                      <td class="action-radio-cell">
                        <div class="action-radio-group">
                          <p-radioButton
                            name="action_{{change.id}}"
                            value="MERGE_SOURCE"
                            [(ngModel)]="change.action"
                            (ngModelChange)="onActionChange(change)"
                            inputId="source_{{change.id}}">
                          </p-radioButton>
                          <label for="source_{{change.id}}" class="radio-label" [pTooltip]="sourceBranch?.refsName" tooltipPosition="top" appendTo="body">{{ sourceBranch?.refsName }}</label>

                          <p-radioButton
                            name="action_{{change.id}}"
                            value="MERGE_TARGET"
                            [(ngModel)]="change.action"
                            (ngModelChange)="onActionChange(change)"
                            inputId="target_{{change.id}}">
                          </p-radioButton>
                          <label for="target_{{change.id}}" class="radio-label" [pTooltip]="targetBranch?.refsName" tooltipPosition="top" appendTo="body">{{ targetBranch?.refsName }}</label>

                          <p-radioButton
                            name="action_{{change.id}}"
                            value="MERGE_LATER"
                            [(ngModel)]="change.action"
                            (ngModelChange)="onActionChange(change)"
                            inputId="dontmerge_{{change.id}}">
                          </p-radioButton>
                          <label for="dontmerge_{{change.id}}" class="radio-label" [pTooltip]="'MERGE_LATER' | translate" tooltipPosition="top" appendTo="body">{{ 'MERGE_LATER' | translate }}</label>
                        </div>
                      </td>
                      <td class="status-cell">
                        <ng-container *ngIf="change.hasError || change.hasConflict">
                          <span class="conflict-text yes">{{ 'YES' | translate }}</span>
                          <i class="pi pi-exclamation-circle status-error-icon"
                             [pTooltip]="getConflictMessages(change)"
                             tooltipPosition="top"></i>
                        </ng-container>
                        <span *ngIf="!change.hasError && !change.hasConflict" class="conflict-text no">
                          {{ 'NO' | translate }}
                        </span>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr class="no-records">
                      <td colspan="6" class="text-center">
                        <div *ngIf="loadingChanges" class="loading-container">
                          <p-progressSpinner></p-progressSpinner>
                        </div>
                        <div class="empty-state" *ngIf="!loadingChanges">
                          <i class="pi pi-check-circle"></i>
                          <span>{{ 'MERGE_NO_CHANGES_FOUND' | translate }}</span>
                        </div>
                      </td>
                    </tr>
                  </ng-template>

                </p-table>
                <!-- Loading more indicator -->
                <div class="loading-more-indicator" *ngIf="loadingMore">
                  <i class="pi pi-spin pi-spinner"></i>
                  <span>{{ 'LOADING_MORE' | translate }}</span>
                </div>
              </div>
          </div>
        </p-tabpanel>
        <p-tabpanel [value]="2">
          <div class="step-content step-3-content">
            <!-- Loading State -->
            <div class="loading-container" *ngIf="loadingReviewChanges">
              <i class="pi pi-spin pi-spinner"></i>
              <span *ngIf="!isMergeInProgress">{{ 'LOADING_REVIEW_DATA' | translate }}</span>
              <span *ngIf="isMergeInProgress">{{ 'MERGE_IN_PROGRESS' | translate }}</span>
            </div>

            <!-- Error State -->
            <div class="review-error" *ngIf="reviewError && !loadingReviewChanges">
              <i class="pi pi-exclamation-triangle"></i>
              <span>{{ reviewError }}</span>
            </div>

            <!-- Step 3 Content -->
            <ng-container *ngIf="!loadingReviewChanges && !reviewError && !showMergeCompletedDialog && !showMergeFailedDialog">
              <!-- Review Filters -->
              <div class="changes-toolbar review-toolbar">
                <div class="filter-dropdowns">


                  <!-- Component Type -->
                  <p-floatlabel variant="on">
                    <p-multiSelect
                      inputId="review-component-type-filter"
                      [options]="reviewComponentTypeOptions"
                      [(ngModel)]="reviewFilterComponentTypes"
                      (ngModelChange)="onReviewFilterChange()"
                      [showClear]="true"
                      [filter]="true"
                      [filterPlaceholder]="'SEARCH' | translate"
                      styleClass="filter-multiselect"
                      appendTo="body">
                    </p-multiSelect>
                    <label for="review-component-type-filter">{{ 'COMPONENT_TYPE' | translate }}</label>
                  </p-floatlabel>
                  <!-- Application Filter (Suite Merge only) -->
                  <p-floatlabel variant="on" *ngIf="isSuiteMerge">
                    <p-multiSelect
                      inputId="review-application-filter"
                      [options]="applicationOptions"
                      [(ngModel)]="reviewFilterApplications"
                      (ngModelChange)="onReviewFilterChange()"
                      [showClear]="true"
                      [filter]="true"
                      styleClass="filter-multiselect"
                      appendTo="body">
                    </p-multiSelect>
                    <label for="review-application-filter">{{ 'APPLICATION' | translate }}</label>
                  </p-floatlabel>
                  <!-- Change Type -->
                  <p-floatlabel variant="on">
                    <p-multiSelect
                      inputId="review-change-type-filter"
                      [options]="changeTypeOptions"
                      [(ngModel)]="reviewFilterChangeTypes"
                      (ngModelChange)="onReviewFilterChange()"
                      [showClear]="true"
                      styleClass="filter-multiselect"
                      appendTo="body">
                    </p-multiSelect>
                    <label for="review-change-type-filter">{{ 'CHANGE_TYPE' | translate }}</label>
                  </p-floatlabel>

                  <button
                    *ngIf="hasActiveReviewFilters"
                    pButton
                    type="button"
                    [label]="'CLEAR_FILTERS' | translate"
                    class="p-button-outlined p-button-sm clear-all-btn"
                    (click)="clearReviewFilters()">
                  </button>
                </div>

                <!-- Summary badges - right aligned -->
                <div class="summary-badges">
                  <span class="summary-badge total">
                    <i class="pi pi-list"></i>
                    <strong>{{ reviewTotalCount }}</strong> {{ 'TOTAL' | translate }}
                  </span>
                  <span class="summary-badge user">
                    <strong>{{ reviewUserSelectedCount }}</strong> {{ 'USER_SELECTED' | translate }}
                  </span>
                  <span class="summary-badge auto" *ngIf="reviewAutoSelectedCount > 0">
                    <strong>{{ reviewAutoSelectedCount }}</strong> {{ 'SYSTEM_SELECTED' | translate }}
                    <i class="pi pi-info-circle info-icon"
                       [pTooltip]="'SYSTEM_SELECTION_TEXT' | translate"
                       tooltipPosition="right"
                       appendTo="body"></i>
                  </span>
                </div>

                <!-- Expand/Collapse buttons -->
                <ng-container *ngIf="reviewAutoSelectedCount > 0">
                    <span class="action-separator">|</span>
                    <button pButton type="button" icon="pi pi-angle-double-down"
                            class="p-button-text p-button-sm expand-collapse-btn"
                            [pTooltip]="'EXPAND_ALL' | translate"
                            tooltipPosition="top"
                            (click)="expandAllGroups()"></button>
                    <button pButton type="button" icon="pi pi-angle-double-up"
                            class="p-button-text p-button-sm expand-collapse-btn"
                            [pTooltip]="'COLLAPSE_ALL' | translate"
                            tooltipPosition="top"
                            (click)="collapseAllGroups()"></button>
                </ng-container>
              </div>

              <!-- Review Table - Flat Display with optional Application column -->
              <div class="review-table-container">
                  <p-table
                    [value]="groupedReviewChanges"
                    [scrollable]="true"
                    scrollHeight="300px"
                    [tableStyle]="{'min-width': '100%'}"
                    styleClass="review-changes-table grouped-table">
                    <ng-template pTemplate="header">
                      <tr>
                        <th scope="col" [style.width]="isSuiteMerge ? '15%' : '11%'">{{ 'MERGE_COMPONENT_TYPE' | translate }}</th>
                        <th *ngIf="isSuiteMerge" scope="col" style="width: 12%;">{{ 'APPLICATION' | translate }}</th>
                        <th scope="col" [style.width]="isSuiteMerge ? '16%' : '10%'">{{ 'CHANGE_TYPE' | translate }}</th>
                        <th scope="col" [style.width]="isSuiteMerge ? '21%' : '25%'">{{ 'SOURCE_INFO' | translate }}</th>
                        <th scope="col" [style.width]="isSuiteMerge ? '21%' : '25%'">{{ 'TARGET_INFO' | translate }}</th>
                        <th scope="col" pResizableColumn style="width: 12%;">{{ 'SELECTED_CHANGES_FROM' | translate }}</th>
                        <th scope="col" [style.width]="isSuiteMerge ? '7%' : '9%'">{{ 'CONFLICTS' | translate }}</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-group>
                      <tr [ngClass]="{'has-conflict': group.parent.hasConflict || hasChildConflict(group), 'expandable-row': group.children.length > 0, 'has-child-conflict': !group.parent.hasConflict && hasChildConflict(group)}"
                          (click)="toggleGroupExpansion(group)">
                        <td class="component-type-cell">
                          <div class="type-cell-with-expand">
                            <i *ngIf="group.children.length > 0"
                               class="pi expand-icon"
                               [ngClass]="group.expanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                            <div class="component-type-content">
                              <span class="component-type-text" [pTooltip]="utilService.formatComponentType(group.parent.componentType)" tooltipPosition="top" appendTo="body">{{ utilService.formatComponentType(group.parent.componentType) }}</span>
                            </div>
                          </div>
                        </td>
                        <td *ngIf="isSuiteMerge">
                          <span>{{ group.parent.applicationName }}</span>
                        </td>
                        <td>
                          <span class="change-type-badge" [ngClass]="getChangeTypeClass(group.parent.recordChangeType)">
                            {{ getChangeTypeDisplayLabel(group.parent) }}
                          </span>
                        </td>
                        <td class="review-combined-source-cell">
                          <div class="combined-cell-content" [class.empty-cell]="!group.parent.sourceComponentName">
                            <div class="component-path-row" *ngIf="group.parent.sourceComponentName">
                              <ng-container *ngIf="group.parent.sourceComponentPath">
                                <span class="path-name" [pTooltip]="getPathName(group.parent.sourceComponentPath)" tooltipPosition="top" appendTo="body">{{ getPathName(group.parent.sourceComponentPath) }}</span>
                                <span class="path-type-badge">{{ getPathTypeLabel(group.parent.sourceComponentPath) }}</span>
                                <i class="path-arrow pi pi-arrow-right"></i>
                              </ng-container>
                              <span class="component-name" [pTooltip]="group.parent.sourceComponentName" tooltipPosition="top" appendTo="body">{{ group.parent.sourceComponentName }}</span>
                              <span class="component-type-badge">{{ utilService.formatComponentType(group.parent.componentType) }}</span>
                            </div>
                            <span class="empty-placeholder" *ngIf="!group.parent.sourceComponentName">-</span>
                            <div class="modification-info" *ngIf="group.parent.lastSourceModifier">
                              <span class="author-name">{{ getUserDisplayName(group.parent.lastSourceModifier) }}</span>
                              <span class="separator">•</span>
                              <span class="author-date">{{ group.parent.lastSourceModification | date:defaultDateTimeDisplayFormat }}</span>
                            </div>
                          </div>
                        </td>
                        <td class="review-combined-target-cell">
                          <div class="combined-cell-content" [class.empty-cell]="!group.parent.targetComponentName">
                            <div class="component-path-row" *ngIf="group.parent.targetComponentName">
                              <ng-container *ngIf="group.parent.targetComponentPath">
                                <span class="path-name" [pTooltip]="getPathName(group.parent.targetComponentPath)" tooltipPosition="top" appendTo="body">{{ getPathName(group.parent.targetComponentPath) }}</span>
                                <span class="path-type-badge">{{ getPathTypeLabel(group.parent.targetComponentPath) }}</span>
                                <i class="path-arrow pi pi-arrow-right"></i>
                              </ng-container>
                              <span class="component-name" [pTooltip]="group.parent.targetComponentName" tooltipPosition="top" appendTo="body">{{ group.parent.targetComponentName }}</span>
                              <span class="component-type-badge">{{ utilService.formatComponentType(group.parent.componentType) }}</span>
                            </div>
                            <span class="empty-placeholder" *ngIf="!group.parent.targetComponentName">-</span>
                            <div class="modification-info" *ngIf="group.parent.lastTargetModifier">
                              <span class="author-name">{{ getUserDisplayName(group.parent.lastTargetModifier) }}</span>
                              <span class="separator">•</span>
                              <span class="author-date">{{ group.parent.lastTargetModification | date:defaultDateTimeDisplayFormat }}</span>
                            </div>
                          </div>
                        </td>
                       <td class="action-display-cell">
                          <span class="action-badge" [ngClass]="'action-' + group.parent.action?.toLowerCase()?.replace('_', '-')">
                            {{ getActionLabel(group.parent.action) }}
                          </span>
                        </td>
                        <td class="status-cell">
                          <div class="status-cell-content">
                            <ng-container *ngIf="group.parent.hasConflict">
                              <span class="conflict-text yes">{{ 'YES' | translate }}</span>
                              <i class="pi pi-exclamation-circle status-error-icon"
                                 [pTooltip]="getConflictMessages(group.parent)"
                                 tooltipPosition="top"
                                 appendTo="body"></i>
                            </ng-container>
                            <ng-container *ngIf="!group.parent.hasConflict && hasChildConflict(group) && !group.expanded">
                              <span class="conflict-text yes">{{ 'YES' | translate }}</span>
                              <i class="pi pi-exclamation-triangle status-warning-icon"
                                 [pTooltip]="'CONFLICT_IN_NESTED_COMPONENTS' | translate"
                                 tooltipPosition="top"
                                 appendTo="body"></i>
                            </ng-container>
                            <span *ngIf="!group.parent.hasConflict && (!hasChildConflict(group) || group.expanded)" class="conflict-text no">
                              {{ 'NO' | translate }}
                            </span>
                            <img *ngIf="hasModelActionTypes(group.parent)"
                                 src="assets/images/svg/where_used_transparent.svg"
                                 alt="View references"
                                 class="references-icon"
                                 [pTooltip]="'SHOW_TARGET_BRANCH_REFERENCES' | translate"
                                 tooltipPosition="top"
                                 appendTo="body"
                                 tabindex="0"
                                 (click)="viewReferences(group.parent, $event)"
                                 (keydown.enter)="viewReferences(group.parent, $event)">
                          </div>
                        </td>
                      </tr>
                      <!-- Child Rows (Auto-selected dependencies) -->
                      <ng-container *ngIf="group.expanded && group.children.length > 0">
                        <tr class="child-section-header">
                          <td [attr.colspan]="isSuiteMerge ? 5 : 4">
                            <div class="section-header-content">
                              <i class="pi pi-info-circle"></i>
                              <span>{{ 'AUTO_SELECTION_TEXT' | translate }}</span>
                            </div>
                          </td>
                        </tr>
                        <tr *ngFor="let child of group.children" class="child-row" [ngClass]="{'has-conflict': child.hasConflict, 'auto-selected-row': !child.hasConflict}">
                          <td class="child-component-type-cell">
                            <div class="child-indent">
                              <span class="tree-connector">└──</span>
                              <span class="component-type-text" [pTooltip]="utilService.formatComponentType(child.componentType)" tooltipPosition="top" appendTo="body">{{ utilService.formatComponentType(child.componentType) }}</span>
                            </div>
                          </td>
                          <td *ngIf="isSuiteMerge">
                            <span>{{ child.applicationName }}</span>
                          </td>
                          <td>
                            <span class="change-type-badge" [ngClass]="getChangeTypeClass(child.recordChangeType)">
                              {{ getChangeTypeDisplayLabel(child) }}
                            </span>
                          </td>
                          <td class="review-combined-source-cell">
                            <div class="combined-cell-content" [class.empty-cell]="!child.sourceComponentName">
                              <div class="component-path-row" *ngIf="child.sourceComponentName">
                                <ng-container *ngIf="child.sourceComponentPath">
                                  <span class="path-name" [pTooltip]="getPathName(child.sourceComponentPath)" tooltipPosition="top" appendTo="body">{{ getPathName(child.sourceComponentPath) }}</span>
                                  <span class="path-type-badge">{{ getPathTypeLabel(child.sourceComponentPath) }}</span>
                                  <i class="path-arrow pi pi-arrow-right"></i>
                                </ng-container>
                                <span class="component-name" [pTooltip]="child.sourceComponentName" tooltipPosition="top" appendTo="body">{{ child.sourceComponentName }}</span>
                                <span class="component-type-badge">{{ utilService.formatComponentType(child.componentType) }}</span>
                              </div>
                              <span class="empty-placeholder" *ngIf="!child.sourceComponentName">-</span>
                              <div class="modification-info" *ngIf="child.lastSourceModifier">
                                <span class="author-name">{{ getUserDisplayName(child.lastSourceModifier) }}</span>
                                <span class="separator">•</span>
                                <span class="author-date">{{ child.lastSourceModification | date:defaultDateTimeDisplayFormat }}</span>
                              </div>
                            </div>
                          </td>
                          <td class="review-combined-target-cell">
                            <div class="combined-cell-content" [class.empty-cell]="!child.targetComponentName">
                              <div class="component-path-row" *ngIf="child.targetComponentName">
                                <ng-container *ngIf="child.targetComponentPath">
                                  <span class="path-name" [pTooltip]="getPathName(child.targetComponentPath)" tooltipPosition="top" appendTo="body">{{ getPathName(child.targetComponentPath) }}</span>
                                  <span class="path-type-badge">{{ getPathTypeLabel(child.targetComponentPath) }}</span>
                                  <i class="path-arrow pi pi-arrow-right"></i>
                                </ng-container>
                                <span class="component-name" [pTooltip]="child.targetComponentName" tooltipPosition="top" appendTo="body">{{ child.targetComponentName }}</span>
                                <span class="component-type-badge">{{ utilService.formatComponentType(child.componentType) }}</span>
                              </div>
                              <span class="empty-placeholder" *ngIf="!child.targetComponentName">-</span>
                              <div class="modification-info" *ngIf="child.lastTargetModifier">
                                <span class="author-name">{{ getUserDisplayName(child.lastTargetModifier) }}</span>
                                <span class="separator">•</span>
                                <span class="author-date">{{ child.lastTargetModification | date:defaultDateTimeDisplayFormat }}</span>
                              </div>
                            </div>
                          </td>
                           <td class="action-display-cell">
                            <span class="action-badge" [ngClass]="'action-' + child.action?.toLowerCase()?.replace('_', '-')">
                              {{ getActionLabel(child.action) }}
                            </span>
                          </td>
                          <td class="status-cell">
                            <div class="status-cell-content">
                              <ng-container *ngIf="child.hasConflict">
                                <span class="conflict-text yes">{{ 'YES' | translate }}</span>
                                <i class="pi pi-exclamation-circle status-error-icon"
                                   [pTooltip]="getConflictMessages(child)"
                                   tooltipPosition="top"
                                   appendTo="body"></i>
                              </ng-container>
                              <span *ngIf="!child.hasConflict" class="conflict-text no">
                                {{ 'NO' | translate }}
                              </span>
                              <img *ngIf="hasModelActionTypes(child)"
                                   src="assets/images/svg/where_used_transparent.svg"
                                   alt="View references"
                                   class="references-icon"
                                   [pTooltip]="'SHOW_TARGET_BRANCH_REFERENCES' | translate"
                                   tooltipPosition="top"
                                   appendTo="body"
                                   tabindex="0"
                                   (click)="viewReferences(child, $event)"
                                   (keydown.enter)="viewReferences(child, $event)">
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td [attr.colspan]="isSuiteMerge ? 7 : 6" class="text-center">
                          <div class="empty-state">
                            <i class="pi pi-inbox"></i>
                            <span>{{ 'NO_COMPONENTS_TO_MERGE' | translate }}</span>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
            </ng-container>
          </div>
        </p-tabpanel>
        <p-tabpanel [value]="3">
          <div class="step-content step-4-content">
            <!-- Merge In Progress Loading State -->
            <div class="loading-container" *ngIf="isMergeInProgress">
              <i class="pi pi-spin pi-spinner"></i>
              <span>{{ 'MERGE_IN_PROGRESS' | translate }}</span>
            </div>

            <!-- Step 4 Confirmation Content -->
            <ng-container *ngIf="!isMergeInProgress">
            <div class="confirmation-header">
              <div class="confirmation-header-text">
                <h3>{{ 'MERGE_CONFIRMATION_SUBTITLE' | translate }}</h3>
              </div>
            </div>
            <div class="confirmation-container">
              <div class="warning-card">
                <i class="pi pi-exclamation-triangle warning-icon"></i>
                <span>
                  <strong class="warning-title">{{ 'MERGE_STEP4_CUSTOM_NOTICE_TITLE' | translate }}</strong><br>
                  {{ 'MERGE_STEP4_CUSTOM_NOTICE_DESC' | translate }}<br><br>
                  <strong>{{ 'MERGE_STEP4_CUSTOM_NOTICE_SUBTITLE' | translate }}</strong><br>
                  1. {{ 'MERGE_STEP4_CUSTOM_NOTICE_STEP1_PREFIX' | translate }} "<strong class="warning-inline-bold">{{ 'MERGE_STEP4_PUBLISH_LABEL' | translate }}</strong>" {{ 'MERGE_STEP4_CUSTOM_NOTICE_STEP1_SUFFIX' | translate }}<br>
                  2. {{ 'MERGE_STEP4_CUSTOM_NOTICE_STEP2' | translate }}<br>
                  3. {{ 'MERGE_STEP4_CUSTOM_NOTICE_STEP3' | translate }}
                </span>
              </div>
              <div class="or-divider">
                <span>{{ 'OR' | translate }}</span>
              </div>
              <div class="publish-card">
                <p class="publish-info-text">
                  {{ 'MERGE_STEP4_NO_CHANGES_1' | translate }}
                  <strong>{{ 'MERGE_STEP4_PUBLISH_LABEL' | translate }}</strong>
                  {{ 'MERGE_STEP4_NO_CHANGES_2' | translate }}
                </p>
                <div class="publish-checkbox-row">
                  <p-checkbox
                    [(ngModel)]="publishAfterMerge"
                    [binary]="true"
                    inputId="publishAfterMergeConfirm">
                  </p-checkbox>
                  <label for="publishAfterMergeConfirm" class="checkbox-label">{{ 'MERGE_STEP4_PUBLISH_LABEL' | translate }}</label>
                </div>
              </div>
            </div>
            </ng-container>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>

  <div class="dialog-footer">
    <div class="d-flex w-100 justify-content-between align-items-center">
      <div class="d-flex align-items-center gap-3">
        <button type="button" (click)="prevStep()" class="btn btn-secondary cancel-btn d-flex align-items-center"
          *ngIf="activeIndex > 0" [disabled]="isMergeInProgress">
          <span class="pi pi-angle-left mr-1 align-middle"></span>
          <span>{{ 'PREVIOUS' | translate }}</span>
        </button>

        <!-- Step 2 Summary - inline in footer -->
        <div class="changes-summary footer-summary" *ngIf="activeIndex === 1">
          <span class="summary-item">
            <strong>{{ totalChangesCount }}</strong> {{ 'TOTAL_CHANGES' | translate }}
            <span *ngIf="hasActiveFilters" class="filtered-count">
              ({{ 'SHOWING' | translate }} {{ filteredChangesCount }} {{ 'FILTERED' | translate }})
            </span>
          </span>
          <span class="summary-item added">
            <i class="pi pi-plus-circle"></i>
            <strong>{{ getChangeCount('ADDED') }}</strong> {{ 'ADDED_LOWERCASE' | translate }}
          </span>
          <span class="summary-item modified">
            <i class="pi pi-pencil"></i>
            <strong>{{ getChangeCount('MODIFIED') }}</strong> {{ 'MODIFIED_LOWERCASE' | translate }}
          </span>
          <span class="summary-item renamed">
            <i class="pi pi-arrow-right-arrow-left"></i>
            <strong>{{ getChangeCount('RENAMED') }}</strong> {{ 'RENAMED_LOWERCASE' | translate }}
          </span>
          <span class="summary-item deleted">
            <i class="pi pi-trash"></i>
            <strong>{{ getChangeCount('DELETED') }}</strong> {{ 'DELETED_LOWERCASE' | translate }}
          </span>
          <span class="summary-item errors" *ngIf="getErrorCount() > 0">
            <i class="pi pi-exclamation-triangle"></i>
            <strong>{{ getErrorCount() }}</strong> {{ 'CONFLICTS' | translate }}
          </span>
        </div>

        <!-- Step 3 Merge Options - inline in footer -->
        <div class="merge-options-inline" *ngIf="activeIndex === 2">
          <div class="merge-option-inline tag-option">
            <p-checkbox
              [ngModel]="true"
              [binary]="true"
              [disabled]="true"
              inputId="createTag">
            </p-checkbox>
            <label class="option-label" for="tagNameInput">{{ 'TAG' | translate }} <span class="required"></span>:</label>
            <i class="pi pi-info-circle info-icon"
               [pTooltip]="'CREATE_TAG_INFO' | translate"
               tooltipPosition="top"
               appendTo="body">
            </i>
            <div class="tag-input-wrapper">
              <input
                id="tagNameInput"
                type="text"
                pInputText
                [(ngModel)]="tagName"
                (ngModelChange)="validateTagName()"
                class="tag-input"
                [class.p-invalid]="tagValidationError"
                [placeholder]="'ENTER_TAG_NAME' | translate">
              <i class="pi pi-spin pi-spinner validation-spinner" *ngIf="isValidatingTag"></i>
              <i class="pi pi-check-circle validation-success" *ngIf="isTagValid && !isValidatingTag"></i>
              <i class="pi pi-exclamation-circle validation-error" *ngIf="tagValidationError && !isValidatingTag"></i>
            </div>
            <small class="tag-error" *ngIf="tagValidationError">{{ tagValidationError }}</small>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <button type="button" class="btn btn-secondary cancel-btn" (click)="onClose()" *ngIf="activeIndex < 3 && !isMergeInProgress">
          {{ 'CANCEL' | translate }}
        </button>
        <ng-container *ngIf="activeIndex === 3">
          <button type="button" class="btn btn-secondary cancel-btn" (click)="onClose()" *ngIf="!isMergeInProgress">
            {{ 'CANCEL' | translate }}
          </button>
          <button type="button" (click)="onSave()" class="btn btn-primary save-btn"
            [disabled]="isMergeInProgress"
            [pTooltip]="getMergeButtonTooltip()"
            tooltipPosition="top">
            {{ 'CONFIRM_MERGE' | translate }}
          </button>
        </ng-container>
        <button type="button" (click)="nextStep()" class="btn btn-secondary cancel-btn next-btn"
          *ngIf="activeIndex < 3"
          [disabled]="!canProceedToNextStep">
          <span>{{ activeIndex === 1 ? ('REVIEW' | translate) : ('NEXT' | translate) }}</span>
          <span class="pi pi-angle-right ml-1 align-middle"></span>
        </button>
      </div>
    </div>
  </div>
</div>
